import { LOCAL_STORAGE_IDS } from "constants/constants";
import { getCookie, setCookie } from "utils/commonMethods";

//Handles authentication controllers.
function useAuthentication() {
  const userIsLoggedIn = function () {
    return getCookie(LOCAL_STORAGE_IDS.USER_TOKEN);
  };

  const setUserToken = function ({ token, id, phone_no }) {
    setCookie(LOCAL_STORAGE_IDS.USER_ID, id);
    setCookie(LOCAL_STORAGE_IDS.USER_PH, phone_no);
    return setCookie(LOCAL_STORAGE_IDS.USER_TOKEN, `Bearer ${token}`);
  };

  const setUserHashToken = function ({ hash }) {
    return setCookie(LOCAL_STORAGE_IDS.USER_HASH_TOKEN, `${hash}`);
  };

  const getUserId = function () {
    return getCookie(LOCAL_STORAGE_IDS.USER_ID);
  };

  return { userIsLoggedIn, setUserToken, getUserId, setUserHashToken };
}

export default useAuthentication;
